import React, { useMemo, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerPng from "leaflet/dist/images/marker-icon.png";
import shadowPng from "leaflet/dist/images/marker-shadow.png";

const DefaultIcon = L.icon({
    iconUrl: markerPng,
    shadowUrl: shadowPng,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

// Move map view when center changes
function ChangeView({ center, zoom }) {
    const map = useMap();
    React.useEffect(() => {
        map.setView(center, zoom);
    }, [center, zoom, map]);
    return null;
}

export default function ProjectLatLongPreview({ lat, lng, onLatLngChange }) {
    const safeLat = parseFloat(lat);
    const safeLng = parseFloat(lng);
    const position = useMemo(() => {
        if (isNaN(safeLat) || isNaN(safeLng)) {
            return [28.0, 77.0]; // Fallback center (e.g., Eastern Mediterranean)
        }
        return [safeLat, safeLng];
    }, [safeLat, safeLng]);
    const markerRef = useRef(null);

    const handleDragEnd = () => {
        const marker = markerRef.current;
        if (marker != null) {
            const { lat, lng } = marker.getLatLng();
            onLatLngChange({ lat, lng });
        }
    };

    return (
        <MapContainer
            center={position}
            zoom={7}
            scrollWheelZoom={true}
            style={{ height: 300, width: "100%", borderRadius: 8 }}
        >
            <TileLayer
                attribution='&copy; OpenStreetMap contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker
                draggable={true}
                eventHandlers={{ dragend: handleDragEnd }}
                position={position}
                ref={markerRef}
            >
                <Popup>
                    Drag me!<br />
                    Lat: {lat}, Lng: {lng}
                </Popup>
            </Marker>
            <ChangeView center={position} zoom={7} />
        </MapContainer>
    );
}
